module.exports = __webpack_public_path__ + "img/logo_icon.ad157321.svg";